import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoadersPlaceholderModule } from './forPlaceholder';
import { LoadersForSpinnerModule } from './forSpinner';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        LoadersPlaceholderModule,
        LoadersForSpinnerModule,
    ],
    exports: [
        LoadersPlaceholderModule,
        LoadersForSpinnerModule,
    ],
    providers: [],
})
export class LoadersTypesModule { }
